import { ArrowUpRight } from "lucide-react";
import { NEWSROOM } from "../../data/content";

export const Newsroom = () => (
  <section className="bg-[#0A0A0A] px-6 lg:px-12 py-24 lg:py-32" data-testid="newsroom-section">
    <p className="font-mono text-xs tracking-[0.35em] text-white/50 flex items-center gap-4 mb-14">
      NEWSROOM <span className="inline-block w-16 h-px bg-white/20" />
    </p>
    <ul className="divide-y divide-white/10 border-y border-white/10">
      {NEWSROOM.map((n, i) => (
        <li key={n.href}>
          <a
            href={n.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`news-item-${i}`}
            className="group flex items-center justify-between gap-8 py-7"
          >
            <div className="flex items-baseline gap-6">
              <span className="font-mono text-[10px] tracking-[0.2em] text-white/30">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-xl sm:text-2xl lg:text-3xl text-white/85 group-hover:text-white leading-snug transition-colors duration-300">
                {n.title}
              </span>
            </div>
            <ArrowUpRight className="shrink-0 w-5 h-5 text-white/30 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
          </a>
        </li>
      ))}
    </ul>
  </section>
);
